import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../resources/img/logo_w.png';


const Privacy = () => {
    return (
        <div className={'privacy'}>
            <div className={'privacy__logo'}>
                <Link to={'/'}>
                    <img className={'privacy__img'} src={Logo} alt="Logo"/>
                </Link>
            </div>

            <p>
                <strong>1. 개인정보의 처리 목적</strong> &lt;Dev09&gt;(‘game.develop09.com’이하 ‘Dev09’) 은(는) 다음의 목적을 위하여 개인정보를
                처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다.<br/><br/>
                ① 당사는 애플 앱스토어, 구글플레이 서비스의 게임센터에서 랭킹 서비스 기능을 이용합니다. 각 스토어의 게임센터를 이용하기위한 ID는 각 스토어의 게임센터에서 관리를 하며, 당사에서는
                개인정보를 별도로 저장하거나 이용하지 않습니다.<br/>
                ② 당사는 구글 애드몹 광고 기능을 이용하지만 개인정보를 별도로 저장하거나 이용하지 않습니다.<br/><br/><br/>
                <p className="lh6 bs4">
                    <strong>2. 개인정보의 처리 및 보유 기간</strong>
                </p>
                ① &lt;Dev09&gt;(‘game.develop09.com’이하 ‘Dev09’) 은(는) 정보주체로부터 개인정보를 수집할 때 동의 받은 개인정보 보유․이용기간 또는 법령에 따른
                개인정보 보유․이용기간 내에서 개인정보를 처리․보유합니다.<br/><br/>
                ② 구체적인 개인정보 처리 및 보유 기간은 다음과 같습니다.<br/>
                ☞ 무료 앱에 포함된 맞춤형 광고를 위한 사용자 접속 정보: 광고 표시와 피드백 내역을 사용하고 즉시 파기합니다.<br/><br/><br/>
                <p className="lh6 bs4">
                    <strong>3. 개인정보의 제3자 제공에 관한 사항</strong>
                </p>
                <p className="ls2">
                    ① 회사는 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.<br/><br/>
                    ② 회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.<br/>
                    - 개인정보를 제공받는 자 : Google AdMob<br/>
                    - 제공받는 자의 개인정보 이용목적 : 지역별 맞춤형 광고를 위해 접속 IP, 서비스 이용 기록 정보 수집<br/>
                    - 제공받는 자의 보유.이용기간: 지체없이 파기
                </p><br/>
                <p className="lh6 bs4">
                    <strong>4. 정보주체와 법정대리인의 권리·의무 및 그 행사방법 이용자는 개인정보주체로써 다음과 같은 권리를 행사할 수 있습니다.</strong>
                </p>
                <p className="ls2">① 정보주체는 Dev09(‘game.develop09.com’이하 ‘Dev09) 에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수
                    있습니다.<br/>
                    1. 개인정보 열람요구<br/>
                    2. 오류 등이 있을 경우 정정 요구<br/>
                    3. 삭제요구<br/>
                    4. 처리정지 요구
                </p><br/>
                <p className='lh6 bs4'>
                    <strong>5. 처리하는 개인정보의 항목 작성 </strong><br/><br/>
                    ① <em className="emphasis">&lt;Dev09&gt;('game.develop09.com'이하 'Dev09')</em>은(는) 다음의 개인정보 항목을 처리하고
                    있습니다.<br/>
                    - 무료 앱에 포함된 맞춤형 광고: 접속 IP, 위치, 서비스 이용 기록 정보
                </p><br/>
                <p className='lh6 bs4'>
                    <strong>6. 개인정보의 파기<em className="emphasis">&lt;Dev09&gt;('Dev09')</em>은(는) 원칙적으로 개인정보 처리목적이 달성된
                        경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.</strong>
                </p>
                <p className='ls2'>
                    -파기절차<br/>
                    이용자가 입력한 정보는 목적 달성 후 즉시 파기됩니다.<br/><br/>
                    -파기기한<br/>
                    이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가
                    불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.
                </p><br/>

                <p className="lh6 bs4">
                    <strong>7. 개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항</strong>
                </p>
                <p className="ls2">Dev09 은 정보주체의 이용정보를 저장하고 수시로 불러오는 ‘쿠키’를 사용하지 않습니다.</p><br/>
                <p className='lh6 bs4'>
                    <strong>8. 개인정보 보호책임자 작성 </strong>
                </p>
                ① Dev09(‘game.develop09.com’이하 ‘Dev09) 은(는) 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을
                위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
                <p className='ls2'><br/>
                    ▶ 개인정보 보호 담당부서<br/>부서명 :개발<br/>연락처: kjwonjg@gmail.com, <br/>
                    ② 정보주체께서는 Dev09(‘game.develop09.com’이하 ‘Dev09) 의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제
                    등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. Dev09(‘game.develop09.com’이하 ‘Dev09) 은(는) 정보주체의 문의에 대해 지체
                    없이 답변 및 처리해드릴 것입니다.
                </p><br/>
                <p className='lh6 bs4'>
                    <strong>9. 개인정보 처리방침 변경 </strong>
                </p>
                <p>①이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.

                </p><br/>
                <p className='lh6 bs4'>
                    <strong>10. 개인정보의 안전성 확보 조치 <em className="emphasis">&lt;Dev09&gt;('Dev09')</em>은(는) 개인정보보호법 제29조에
                        따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.</strong>
                </p
                ><p className='ls2'>1. 내부관리계획의 수립 및 시행<br/> 개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.<br/><br/>2. 개인정보의
                암호화<br/> 이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는
                등의 별도 보안기능을 사용하고 있습니다.<br/><br/>
            </p>
            </p>
        </div>
    );
}

export default Privacy;